import { render, staticRenderFns } from "./taxation.vue?vue&type=template&id=71094376"
import script from "./taxation.vue?vue&type=script&lang=js"
export * from "./taxation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports